<template>
  <div class="md:flex md:justify-between">
    <!-- section start -->
    <!-- todo make it slots -->
    <div class="md:flex hidden text-white mx-1">
      <div
        class="bg-pink-600 w-12 rounded-md text-center mr-6 hidden"
        style="background-color: #72256d"
      >
        <span class="flex justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6 mt-[12px]"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M3.124 7.5A8.969 8.969 0 015.292 3m13.416 0a8.969 8.969 0 012.168 4.5"
            />
          </svg>
        </span>
      </div>
      <div
        class="border border-color w-32 rounded-md text-center ml-3"
        v-if="!getStatus"
      >
        <router-link to="/login">
          <span class="flex justify-center text-center pt-3 cursor-pointer text-md px-1">
            تسجيل دخول
          </span>
        </router-link>
      </div>
      <div
        class="border border-color w-32 rounded-md text-center ml-3"
        v-if="!getStatus"
      >
        <span
          class="flex justify-center text-center pt-3 cursor-pointer text-md"
          @click="subscribe"
        >
          <div
            v-show="loading"
            class="animate-spin inline-block w-4 h-4 mr-2 mt-1 border-[3px] border-current border-t-transparent text-pink-600 rounded-full"
            role="status"
            aria-label="loading"
          >
            <span class="sr-only">Loading...</span>
          </div>
          إشتراك
        </span>
      </div>

      <div v-else>
        <div class="">
          <div class="md:flex justify-between hidden">
          
            <button
              class="mx-2 text-gray-100 font-semibold py-2.5 px-6 text-md border border-color rounded shadow flex justify-center"
              @click="logoutAction"
            >
              تسجيل خروج
            </button>
          </div>
        </div>
      </div>
      <div class="relative ml-12">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="#C43670"
          class="w-6 h-6 absolute top-3 left-2 cursor-pointer"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
          />
        </svg>
        <input
          type="text"
          class="p-3 px-3 rounded-md lg:w-80 md:w-56 bg-black outline-none border border-color"
          dir="rtl"
          placeholder="   البحث  "
          @focusout="handleChange"
        />
      </div>
    </div>
    <!-- todo make it slots -->
    <div class="flex justify-between text-white xsm:mx-1 mx-3" dir="rtl">
      <div>
        <!-- todo make it slots -->
        <span class="md:text-4xl text-2xl font-bold text-whtie">{{ title }}</span>
        <!-- todo make it slots -->
        <div class="hidden md:block border border-b-[4px] border-pink-600"></div>
      </div>
      <div class="md:hidden flex justify-between" v-if="!getStatus">
        <button
          class="mx-2 text-gray-100 font-semibold py-2 px-6 text-md xsm:px-6 xsm:text-xs border border-color rounded shadow flex justify-center"
          @click="subscribe"
        >
          إشتراك
          <div
            v-show="loading"
            class="animate-spin inline-block w-4 h-4 mr-1 border-[3px] border-current border-t-transparent text-pink-600 rounded-full"
            role="status"
            aria-label="loading"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </button>
        <router-link to="/login">
          <button
            class="mx-2 text-gray-100 font-semibold py-2 px-6 text-md xsm:px-1 xsm:text-xs border border-color rounded shadow flex justify-center"
          >
            تسجيل دخول
          </button>
        </router-link>
      </div>
      <div v-else>
        <div class="">
          <div class="md:hidden flex justify-between">
          

            <button
              class="mx-2 text-gray-100 font-semibold py-2 px-6 text-md xsm:px-1 xsm:text-xs border border-color rounded shadow flex justify-center"
              @click="logOut"
            >
              تسجيل خروج
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import { mapActions, mapState } from "pinia";

export default {
  props: ["title"],
  emits: ["search"],
  data() {
    return {
      loading: false,
      isActive: false,
    };
  },
  computed: {
    ...mapState(useAuthStore, ["getStatus"]),
  },
  watch: {
    getStatus: {
      immediate: true,
      //eslint-disable-next-line
      handler(newValue, oldValue) {},
    },

    // whenever question changes, this function will run
    // eslint-disable-next-line
    isActive(newValue, oldValue) {},
  },
  methods: {
    async checkIsActiveAction() {
      return (this.isActive = localStorage.getItem("isActive"));
    },
    ...mapActions(useAuthStore, ["unsubscribe", "logOut", "subscribeAction"]),
    async logoutAction() {
      await this.logOut();
      this.isActive=false;
      if (!this.getStatus) return this.$router.push({ name: "home" });
    },
    async UnSubscribe() {
      try {
        await this.unsubscribe().then((response) => this.redirectUser(response));
      } catch (error) {
        console.log(error);
      }
    },
    async redirectUser(response) {
      if (!response.data.status && !response.data.isActive) {
        return this.$router.push({ name: "home" });
      }
    },
    getUserData() {
      this.status = localStorage.getItem("status");
      if (localStorage.getItem("user")) {
        this.phone = JSON.parse(localStorage.getItem("user")).phone;
      }
    },
    handleChange(event) {
      this.$emit("search", event.target.value);
    },
    async subscribe() {
      this.loading = true;
      await this.subscribeAction();

      this.loading = false;
    },
  },
  async mounted() {
    await this.checkIsActiveAction();
  },
};
</script>

<style></style>
